import NavigationService from '../../modules/Navigator/navigators/NavigationService';

export default function getCurrentScreen(currentState) {
  let state = currentState || NavigationService.state();
  if (!state) {
    return null;
  }
  while (
    typeof state.routes[state.index].index !== 'undefined' ||
    state.routes[state.index].state
  ) {
    state = state.routes[state.index].state || state.routes[state.index];
  }
  if (state.routes) {
    return state.routes[state.index].name;
  } else {
    return state.name;
  }
}
